import { useState} from 'react';
import dayjs from 'dayjs';
import Loader from '../../Loader';
const Confirm = (props) => {
     const serviceInfo = props.globalServiceTypes.find(
      service => service.key === props.serviceType
  );
    let service_title = serviceInfo?.label || 'Service';
   
  const [loading, setLoading] = useState(false);

    const handleCloseButton = (e) => {
        e.preventDefault();
        props.goBackToHomePage();
    }
   
      
    return (
        <div>

            <div className="w-full flex justify-end mb-3">
                <button onClick={handleCloseButton}>
                <svg xmlns="http://www.w3.org/2000/svg" className="cursor-pointer"
                    width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM19.3 19.3C18.91 19.69 18.28 19.69 17.89 19.3L15 16.41L12.11 19.3C11.72 19.69 11.09 19.69 10.7 19.3C10.5127 19.1132 10.4075 18.8595 10.4075 18.595C10.4075 18.3305 10.5127 18.0768 10.7 17.89L13.59 15L10.7 12.11C10.5127 11.9232 10.4075 11.6695 10.4075 11.405C10.4075 11.1405 10.5127 10.8868 10.7 10.7C11.09 10.31 11.72 10.31 12.11 10.7L15 13.59L17.89 10.7C18.28 10.31 18.91 10.31 19.3 10.7C19.69 11.09 19.69 11.72 19.3 12.11L16.41 15L19.3 17.89C19.68 18.27 19.68 18.91 19.3 19.3Z" fill="#333333" />
                </svg>
                </button>
            </div>
            {(loading) && <div className="w-full flex justify-center mb-3"><Loader fullHeight={false} /></div>}
         <div>
            <p className="text-xl font-light">Dear {props.account?.client_name}</p>

           
                <div>
                <div className="md:py-8 py-5 text-center flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto" width="55" height="40" viewBox="0 0 55 40" fill="none">
<path d="M54.9334 2.10089L18.4624 37.9541L16.3755 40L14.3418 37.8991L0.0703125 23.1661L2.15868 21.1187L16.4287 35.8532L52.8997 0L54.9334 2.10089Z" fill="#EE5253"/>
<path d="M18.2871 37.7758L16.3802 39.6454L14.5214 37.7252L14.5214 37.7252L0.42278 23.1706L2.15408 21.4733L16.2491 36.0271L16.4243 36.208L16.6039 36.0315L52.8953 0.354896L54.5812 2.09653L18.2874 37.7756L18.2871 37.7758Z" stroke="#333333" strokeOpacity="0.08" strokeWidth="0.5"/>
</svg>

                </div>
               
                 
                    <p className="uppercase md:text-3xl text-2xl font-extralight pb-7 text-center w-full">Inspection Confirmed</p> 
                

                </div>
                

              
               

                    
                <div className="gap-2.5 flex flex-col">
                <p className="text-center w-full text-sm font-normal">Your {service_title} Inspection for has been successfully scheduled.</p>
                  </div>

                <div className="w-full border-t py-2 mt-5  border-b border-primary/30">
                    <div className="table align-middle w-full">
                        <div className="table-row text-sm font-normal text-primary">
                            <div className="table-cell w-full">
                                PROPERTY DETAILS
                            </div>
                           
                        </div>
                        <div className="table-row text-xs font-normal text-primary">
                            <div className="table-cell w-full">
                         
                         
                              <div>
                                    {props.primaryPropertyAddress}
                                    
                                </div>
                            



                            </div>
                         
                        </div>

                    </div>

                </div>

                  <div className="w-full py-2 mt-0  border-b border-primary/30">
                    <div className="table align-middle w-full">
                        <div className="table-row text-sm font-normal text-primary">
                            <div className="table-cell w-6/12">
                                INSPECTION DATE
                            </div>
                            <div className="table-cell w-6/12 text-right">
                                TIME
                            </div>
                        </div>
                        <div className="table-row text-xs font-normal text-primary">
                            <div className="table-cell w-6/12">
                         
                         
                              <div>
                                    {dayjs(props.selectedDate).format('MMMM D, YYYY')}
                                </div>
                            



                            </div>
                            <div className="table-cell w-6/12 text-right">
                           

                        
                           
                                <div>{props.selectedTimeSlot}</div>
                            




                            </div>
                        </div>

                    </div>

                </div>
             
             
           

               
             <div className="text-primary text-xs py-5 text-justify">
            A confirmation has also been sent to your registered email.
             </div>
              
              

                <button className="w-full bg-danger text-white py-2 text-sm rounded font-bold hover:bg-danger/90"
                    onClick={handleCloseButton}
                >Go to Home Page</button>





            </div>

        </div>
    );
}
export default Confirm;